module.exports = __webpack_public_path__ + "static/media/reloca.55569fe8.webp";